import { User } from "src/app/core/interfaces/user.interface";
import { ChangePasswordPayload } from "./user-profile.model";

export class LoadMyProfile {
  public static readonly type = "[UserProfile] load my profile";
}

export class UpdateProfile {
  public static readonly type = "[UserProfile] update profile";
  constructor(public readonly payload: User) {}
}

export class ResetSuccess {
  public static readonly type = "[UserProfile] reset success";
}

export class ChangePassword {
  public static readonly type = "[UserProfile] change password";
  constructor(public readonly payload: ChangePasswordPayload) {}
}
